module.exports = __webpack_public_path__ + "img/Flag_of_Jamaica.5265be7e.svg";